"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwitchUserHoldingView = void 0;
class SwitchUserHoldingView {
    constructor(holdingRepository) {
        this.holdingRepository = holdingRepository;
    }
    execute(request) {
        return this.holdingRepository.switchUserHoldingView(request);
    }
}
exports.SwitchUserHoldingView = SwitchUserHoldingView;
